import { MarkdownContentPage } from "@/components/content/MarkdownContentPage";
import { contentPages } from "@/content/content-pages";

export default function PrivacyPolicyPage() {
  return <MarkdownContentPage content={contentPages["privacy-policy"]} />;
}
